import { type RootState } from '../rmsStore'

export default function getUsbCertificatesReducer (state: RootState): UsbCertificatesState {
  return state.usbCertificatesReducer
}